import React from 'react';

export default ({ ...props }) => (
  <img
    {...props}
    className="Lazy"
    data-src="//cdn.allbirds.com/image/upload/v1586480614/icons/filters.svg"
    alt="Filters Icon"
  />
);
